import { render, staticRenderFns } from "./DeferredPayments.vue?vue&type=template&id=205699e9&scoped=true"
import script from "./DeferredPayments.vue?vue&type=script&lang=js"
export * from "./DeferredPayments.vue?vue&type=script&lang=js"
import style0 from "./DeferredPayments.vue?vue&type=style&index=0&id=205699e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205699e9",
  null
  
)

export default component.exports